<template>
  <div class="product">
    <ProductCard v-if="teaser" :rate="rate" title="Cyber insurance" />
    <ProductConfig v-else class="product-config" :rate="rate">
      <div class="container-wrap">
        <AppSelect
          v-model="form.liabilityLimit"
          placeholder="Select amount"
          help="This covers your liability for failing to protect data, as well as penalties for not complying with data protection law."
          @input="handleInput"
        >
          <div slot="label">
            Select your limit for cyber insurance
          </div>
          <option v-for="value in liabilityLimits" :key="value" :value="value">
            {{ value | currency }}
          </option>
        </AppSelect>
      </div>

      <template v-if="rate.config.options.cybercrime">
        <div class="container-wrap bg-white">
          <AppSelect
            v-model="form.cybercrime"
            placeholder="Select amount"
            @input="handleInput"
          >
            <div slot="label">
              Want to include cover for your own financial losses from fraudulent instructions (social engineering), funds transfer fraud, telephone hacking, botnet attacks or cryptojacking?
            </div>
            <option v-for="(option, i) in rate.config.options.cybercrime" :key="i" :value="option.value">
              {{ option.label || option.value | currency }}
            </option>
          </AppSelect>
        </div>
      </template>

      <div class="container-wrap" :class="{ 'bg-white': !rate.config.options.cybercrime }">
        <AppSelect
          v-model="form.notificationLimit"
          placeholder="Select amount"
          help="Personally Identifiable Information is data which can be used to uniquely identify, contact or locate a single person, or can be used with other sources to uniquely identify a single person."
          @input="handleInput"
        >
          <div slot="label">
            For how many people do you hold Personally Identifiable Information?
          </div>
          <option v-for="value in notificationLimits" :key="value" :value="value">
            Up to {{ value | numberWithCommas('None') }}
          </option>
        </AppSelect>
      </div>
      <div v-if="$store.getters.getHasNorthAmericanCustomers" class="container-wrap">
        <p class="text-base font-bold block">
          Do you want to include cover for claims brought against you in courts in the USA and Canada?
        </p>
        <AppSelect v-model="form.worldwideJurisdiction" placeholder="Select amount" @input="handleInput">
          <option value="0">No</option>
          <option value="1">Yes</option>
        </AppSelect>
      </div>
    </ProductConfig>
  </div>
</template>

<script>
import ProductCard from '@/components/products/Card.vue'
import ProductConfig from '@/components/products/Config.vue'
import AppSelect from '@/components/products/form/Select.vue'
import rateMixin from '@/mixins/rate'

export default {
  filters: {
    numberWithCommas: (val, zeroValue) => {
      return val > 0 ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : zeroValue
    },
  },
  components: {
    ProductCard,
    ProductConfig,
    AppSelect,
  },
  mixins: [rateMixin],
  props: {
    teaser: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Object,
      required: true,
    },
  },
  data () {
    if (this.teaser) return {}

    const defaultRatingInputs = {
      id: 'ProfessionalInsurance',
      key: 'ProfessionalInsurance\\CyberSecurity',
      active: true,
      description: 'Cyber Security',
      liabilityLimit: null,
      cybercrime: 0,
      notificationLimit: null,
      worldwideJurisdiction: 0,
    }

    // overwrite defaults with what ratingEngine returns
    let ratingInputs = { ...defaultRatingInputs, ...this.rate.ratingInputs }

    // if there's a rate passed, overwrite default inputs
    const rate = this.getRate(this.rate.key)
    if (rate) ratingInputs = { ...ratingInputs, ...rate.ratingInputs }

    let liabilityLimits = ['250000', '500000', '750000', '1000000', '2000000']
    if (this.$store.getters.getTurnover >= 25000000) { liabilityLimits = ['250000', '500000', '750000', '1000000', '2000000', '3000000', '4000000', '5000000'] }

    return {
      productKey: 'CyberSecurity',
      loading: false,
      liabilityLimits,
      notificationLimits: ['5000', '10000', '25000', '50000', '100000', '250000'],
      form: {
        ...ratingInputs,
        // can't access this.getters here - need to access directly via $store
        productUuid: this.getAvailableProduct('ProfessionalInsurance').id,
        industryId: this.$store.getters.getIndustryId,
        turnover: this.$store.getters.getTurnover,
        employeeCount: this.$store.getters.getEmployeeCount,
      },
    }
  },
  mounted () {
    if (!this.teaser) {
      this.handleSubmit()
    }
  },
  methods: {
    validate () {
      if (!this.form.liabilityLimit || !this.form.notificationLimit) return false

      return true
    },
    handleSubmit () {
      // reset estimate if it has already been submitted for this rate
      this.$store.commit('updateEstimate', null)

      if (!this.validate()) {
        return
      }

      this.loading = true

      this.updateRate(this.form)
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false))
    },
    handleInput () {
      this.handleSubmit()
    },
  },
}
</script>
